import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { ref: "root" }
const _hoisted_2 = ["id"]
const _hoisted_3 = { class: "opblock-summary-method" }
const _hoisted_4 = ["data-path"]
const _hoisted_5 = { class: "nostyle" }
const _hoisted_6 = ["id"]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "openapi-tooltiptext" }
const _hoisted_9 = ["id"]
const _hoisted_10 = { class: "opblock-description-wrapper" }
const _hoisted_11 = { class: "opblock-description" }
const _hoisted_12 = { class: "renderedMarkdown" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = { class: "opblock-section" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "opblock-section-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "tab-header" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "tab-item active" }, [
      /*#__PURE__*/_createElementVNode("h4", { class: "opblock-title" }, [
        /*#__PURE__*/_createElementVNode("span", null, "Parameters")
      ])
    ])
  ])
], -1)
const _hoisted_17 = { class: "parameters-container" }
const _hoisted_18 = {
  key: 0,
  class: "opblock-description-wrapper"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", null, "No parameters", -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = {
  key: 1,
  class: "table-container"
}
const _hoisted_22 = { class: "parameters" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "col_header parameters-col_name" }, "Name"),
    /*#__PURE__*/_createElementVNode("th", { class: "col_header parameters-col_description" }, " Description ")
  ])
], -1)
const _hoisted_24 = ["data-param-name", "data-param-in"]
const _hoisted_25 = { class: "parameters-col_name" }
const _hoisted_26 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_27 = { class: "parameter__type" }
const _hoisted_28 = { class: "parameter__in" }
const _hoisted_29 = { class: "parameters-col_description" }
const _hoisted_30 = { class: "renderedMarkdown" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { key: 1 }
const _hoisted_33 = ["onUpdate:modelValue", "id", "placeholder"]
const _hoisted_34 = {
  key: 0,
  class: "opblock-section opblock-section-request-body"
}
const _hoisted_35 = { class: "opblock-section-header" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("h4", { class: "opblock-title parameter__name undefined" }, " Request body ", -1)
const _hoisted_37 = { class: "content-type-wrapper body-param-content-type" }
const _hoisted_38 = ["id"]
const _hoisted_39 = ["value"]
const _hoisted_40 = { class: "opblock-description-wrapper" }
const _hoisted_41 = { class: "body-param" }
const _hoisted_42 = ["id"]
const _hoisted_43 = {
  key: 1,
  class: "opblock-section opblock-section-request-body"
}
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "opblock-section-header" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "opblock-title parameter__name undefined" }, " Request body template ")
], -1)
const _hoisted_45 = { class: "opblock-description-wrapper" }
const _hoisted_46 = { class: "opblock-description" }
const _hoisted_47 = { class: "renderedMarkdown" }
const _hoisted_48 = {
  key: 2,
  class: "opblock-section opblock-section-request-body"
}
const _hoisted_49 = { class: "opblock-section-header" }
const _hoisted_50 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "currentColor",
  class: "bi bi-arrows-expand",
  viewBox: "0 0 16 16"
}
const _hoisted_51 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M1 8a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 8zM7.646.146a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 1.707V5.5a.5.5 0 0 1-1 0V1.707L6.354 2.854a.5.5 0 1 1-.708-.708l2-2zM8 10a.5.5 0 0 1 .5.5v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 0 1 .708-.708L7.5 14.293V10.5A.5.5 0 0 1 8 10z"
}, null, -1)
const _hoisted_52 = [
  _hoisted_51
]
const _hoisted_53 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "currentColor",
  class: "bi bi-arrows-collapse",
  viewBox: "0 0 16 16"
}
const _hoisted_54 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M1 8a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 8zm7-8a.5.5 0 0 1 .5.5v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 1 1 .708-.708L7.5 4.293V.5A.5.5 0 0 1 8 0zm-.5 11.707-1.146 1.147a.5.5 0 0 1-.708-.708l2-2a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 11.707V15.5a.5.5 0 0 1-1 0v-3.793z"
}, null, -1)
const _hoisted_55 = [
  _hoisted_54
]
const _hoisted_56 = {
  key: 0,
  class: "opblock-description-wrapper"
}
const _hoisted_57 = { class: "opblock-description" }
const _hoisted_58 = { class: "renderedMarkdown" }
const _hoisted_59 = ["innerHTML"]
const _hoisted_60 = ["innerHTML"]
const _hoisted_61 = {
  key: 0,
  class: "execute-wrapper"
}
const _hoisted_62 = ["id", "data-operation-suffix", "data-operation-path", "data-operation-http-method", "disabled"]
const _hoisted_63 = { class: "responses-wrapper" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("div", { class: "opblock-section-header" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Responses")
], -1)
const _hoisted_65 = { class: "responses-inner" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("h4", { style: {"display":"none"} }, "Server response", -1)
const _hoisted_67 = {
  key: 0,
  class: "responses-table live-responses-table"
}
const _hoisted_68 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "responses-header" }, [
    /*#__PURE__*/_createElementVNode("td", { class: "col_header response-col_status" }, "Code"),
    /*#__PURE__*/_createElementVNode("td", { class: "col_header response-col_description" }, " Details ")
  ])
], -1)
const _hoisted_69 = { class: "response" }
const _hoisted_70 = { class: "response-col_status" }
const _hoisted_71 = ["id"]
const _hoisted_72 = { class: "response-col_description" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("h5", null, "Response body", -1)
const _hoisted_74 = { class: "highlight-code" }
const _hoisted_75 = ["id"]
const _hoisted_76 = /*#__PURE__*/_createElementVNode("div", { class: "d-none" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "Response headers"),
  /*#__PURE__*/_createElementVNode("pre", { class: "microlight" })
], -1)
const _hoisted_77 = /*#__PURE__*/_createElementVNode("h4", null, "Responses", -1)
const _hoisted_78 = { class: "responses-table" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "responses-header" }, [
    /*#__PURE__*/_createElementVNode("td", { class: "col_header response-col_status" }, "Code"),
    /*#__PURE__*/_createElementVNode("td", { class: "col_header response-col_description" }, " Description "),
    /*#__PURE__*/_createElementVNode("td", { class: "col col_header response-col_links" }, "Links")
  ])
], -1)
const _hoisted_80 = ["data-code"]
const _hoisted_81 = { class: "response-col_status" }
const _hoisted_82 = { class: "response-col_description" }
const _hoisted_83 = { class: "response-col_description__inner" }
const _hoisted_84 = { class: "renderedMarkdown" }
const _hoisted_85 = ["onClick"]
const _hoisted_86 = { key: 1 }
const _hoisted_87 = { class: "response-controls" }
const _hoisted_88 = { class: "response-control-media-type response-control-media-type--accept-controller" }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("small", { class: "response-control-media-type__title" }, "Media type", -1)
const _hoisted_90 = { class: "content-type-wrapper" }
const _hoisted_91 = ["id"]
const _hoisted_92 = ["value"]
const _hoisted_93 = /*#__PURE__*/_createElementVNode("small", { class: "response-control-media-type__accept-message" }, [
  /*#__PURE__*/_createTextVNode(" Controls "),
  /*#__PURE__*/_createElementVNode("code", null, "Accept"),
  /*#__PURE__*/_createTextVNode(" header. ")
], -1)
const _hoisted_94 = /*#__PURE__*/_createElementVNode("td", { class: "response-col_links" }, [
  /*#__PURE__*/_createElementVNode("i", null, "No links")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["opblock is-open", 'opblock-' + _ctx.operationKey.toLowerCase()]),
      id: 'operations-default-' + _ctx.operationSuffix
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["opblock-summary", 'opblock-summary-' + _ctx.operationKey.toLowerCase()]),
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleCollapse && _ctx.toggleCollapse(...args)))
      }, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.operationKey.toUpperCase()), 1),
        _createElementVNode("span", {
          class: "opblock-summary-path",
          "data-path": _ctx.pathKey
        }, [
          _createElementVNode("a", _hoisted_5, [
            _createElementVNode("span", null, "​" + _toDisplayString(_ctx.pathKey), 1)
          ])
        ], 8, _hoisted_4),
        _createElementVNode("div", {
          class: "opblock-summary-description",
          id: 'op-summary-description' + _ctx.operationSuffix
        }, [
          (_ctx.editorMode)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass(["editable-field", { empty: !_ctx.operation.summary }]),
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.editMethodShortDescr()), ["stop"]))
              }, _toDisplayString(_ctx.operation.summary || "Add method short description..."), 3))
            : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.operation.summary || ""), 1))
        ], 8, _hoisted_6),
        (!_ctx.editorMode)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.copyUrlToClipboard && _ctx.copyUrlToClipboard(...args)), ["stop"])),
              class: "openapi-custom-anchor openapi-tooltip"
            }, [
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("apiDoc.openApi.operation.copyLinkToClipboard")), 1)
            ]))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("div", null, [
        (!_ctx.collapsed)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "opblock-body",
              id: 'opbody' + _ctx.operationSuffix,
              style: {"height":"auto","border":"none","margin":"0px","padding":"0px"}
            }, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    (_ctx.editorMode)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: _normalizeClass(["editable-field", { empty: !_ctx.operation.description }]),
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.editMethodLongDescr())),
                          innerHTML: 
										_ctx.sanitize(_ctx.operation.description || 'Add method long description...')
									
                        }, null, 10, _hoisted_13))
                      : (_openBlock(), _createElementBlock("span", {
                          key: 1,
                          innerHTML: _ctx.sanitize(_ctx.operation.description || '')
                        }, null, 8, _hoisted_14))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("div", _hoisted_17, [
                  (_ctx.parameters.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20))
                    : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        _createElementVNode("table", _hoisted_22, [
                          _hoisted_23,
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parameters, (param) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                "data-param-name": param.name,
                                "data-param-in": param.In
                              }, [
                                _createElementVNode("td", _hoisted_25, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["parameter__name", { required: param.required }])
                                  }, [
                                    _createTextVNode(_toDisplayString(param.name) + " ", 1),
                                    (param.required)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_26, " *"))
                                      : _createCommentVNode("", true)
                                  ], 2),
                                  _createElementVNode("div", _hoisted_27, _toDisplayString(param.schema.type), 1),
                                  _createElementVNode("div", _hoisted_28, _toDisplayString(param.in), 1)
                                ]),
                                _createElementVNode("td", _hoisted_29, [
                                  _createElementVNode("div", _hoisted_30, [
                                    (_ctx.editorMode)
                                      ? (_openBlock(), _createElementBlock("span", {
                                          key: 0,
                                          class: _normalizeClass(["editable-field", { empty: !param.description }]),
                                          onClick: ($event: any) => (_ctx.editParamDescr(param.name))
                                        }, _toDisplayString(param.description ||
															"Add parameter description..."), 11, _hoisted_31))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(param.description || ""), 1))
                                  ]),
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": ($event: any) => ((_ctx.request.params[param.name]) = $event),
                                    id: 'input' + _ctx.operationSuffix + param.name,
                                    type: "text",
                                    class: "",
                                    title: "",
                                    placeholder: param.name
                                  }, null, 8, _hoisted_33), [
                                    [_vModelText, _ctx.request.params[param.name]]
                                  ])
                                ])
                              ], 8, _hoisted_24))
                            }), 256))
                          ])
                        ])
                      ]))
                ]),
                (_ctx.operation.requestBody && _ctx.showExecutorUI)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        _hoisted_36,
                        _createElementVNode("label", null, [
                          _createElementVNode("div", _hoisted_37, [
                            _withDirectives(_createElementVNode("select", {
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.request.contentType) = $event)),
                              id: 'select-content-type' + _ctx.operationSuffix,
                              class: "content-type",
                              onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.contentTypeChanged()))
                            }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(
													_ctx.operation.requestBody.content
												), (contentType) => {
                                return (_openBlock(), _createElementBlock("option", { value: contentType }, _toDisplayString(contentType), 9, _hoisted_39))
                              }), 256))
                            ], 40, _hoisted_38), [
                              [_vModelSelect, _ctx.request.contentType]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_41, [
                              _withDirectives(_createElementVNode("textarea", {
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.request.body) = $event)),
                                id: 'textarea' + _ctx.operationSuffix,
                                class: "body-param__text"
                              }, null, 8, _hoisted_42), [
                                [_vModelText, _ctx.request.body]
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.editorMode && _ctx.operation.requestBody)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                      _hoisted_44,
                      _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("div", _hoisted_46, [
                          _createElementVNode("div", _hoisted_47, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["editable-field method-request-body-template", { empty: !_ctx.requestBodyTemplate }]),
                              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.editRequestBodyTemplate()))
                            }, _toDisplayString(_ctx.requestBodyTemplate || "Add request body template..."), 3)
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.editorMode || _ctx.methodExample)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                      _createElementVNode("div", _hoisted_49, [
                        _createElementVNode("h4", {
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.toggleMethodExample())),
                          class: "opblock-title parameter__name undefined",
                          style: {"cursor":"pointer"}
                        }, [
                          _createTextVNode(_toDisplayString(_ctx.$t("apiDoc.openApi.operation.examples")) + " ", 1),
                          (!_ctx.isMethodExampleExpanded)
                            ? (_openBlock(), _createElementBlock("svg", _hoisted_50, _hoisted_52))
                            : _createCommentVNode("", true),
                          (_ctx.isMethodExampleExpanded)
                            ? (_openBlock(), _createElementBlock("svg", _hoisted_53, _hoisted_55))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      (_ctx.isMethodExampleExpanded)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                            _createElementVNode("div", _hoisted_57, [
                              _createElementVNode("div", _hoisted_58, [
                                (_ctx.editorMode)
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 0,
                                      class: _normalizeClass(["editable-field", { empty: !_ctx.methodExample }]),
                                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.editMethodExample())),
                                      innerHTML: _ctx.sanitize(_ctx.methodExample || 'Add method example...')
                                    }, null, 10, _hoisted_59))
                                  : (_openBlock(), _createElementBlock("span", {
                                      key: 1,
                                      innerHTML: _ctx.sanitize(_ctx.methodExample || '')
                                    }, null, 8, _hoisted_60))
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.showExecutorUI)
                ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                    _createElementVNode("button", {
                      id: 'btn-execute' + _ctx.operationSuffix,
                      class: "btn execute opblock-control__btn",
                      "data-operation-suffix": _ctx.operationSuffix,
                      "data-operation-path": _ctx.pathKey,
                      "data-operation-http-method": _ctx.operationKey,
                      "data-text-loading": "Loading...",
                      onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.execute && _ctx.execute(...args))),
                      disabled: _ctx.executeInProgress
                    }, _toDisplayString(_ctx.executeInProgress ? "Loading..." : "Execute"), 9, _hoisted_62)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_63, [
                _hoisted_64,
                _createElementVNode("div", _hoisted_65, [
                  _createElementVNode("div", null, [
                    _hoisted_66,
                    (_ctx.showExecutorUI)
                      ? (_openBlock(), _createElementBlock("table", _hoisted_67, [
                          _hoisted_68,
                          _createElementVNode("tbody", null, [
                            _createElementVNode("tr", _hoisted_69, [
                              _createElementVNode("td", _hoisted_70, [
                                _createElementVNode("span", {
                                  id: 'response-code' + _ctx.operationSuffix
                                }, _toDisplayString(_ctx.executeResult.statusCode), 9, _hoisted_71)
                              ]),
                              _createElementVNode("td", _hoisted_72, [
                                _createElementVNode("div", null, [
                                  _hoisted_73,
                                  _createElementVNode("div", _hoisted_74, [
                                    (_ctx.executeResult.content)
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 0,
                                          class: "download-contents",
                                          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.downloadResponseContent()))
                                        }, _toDisplayString(_ctx.$t("apiDoc.openApi.operation.download")), 1))
                                      : _createCommentVNode("", true),
                                    (_ctx.executeResult.content)
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 1,
                                          class: "copy-contents",
                                          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.copyResponseContent()))
                                        }, _toDisplayString(_ctx.$t("apiDoc.openApi.operation.copy")), 1))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("pre", {
                                      id: 'response-container' + _ctx.operationSuffix,
                                      class: "microlight"
                                    }, _toDisplayString(_ctx.executeResult.content), 9, _hoisted_75)
                                  ])
                                ]),
                                _hoisted_76
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_77
                  ]),
                  _createElementVNode("table", _hoisted_78, [
                    _hoisted_79,
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.responses, (response) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          class: "response",
                          "data-code": response.code
                        }, [
                          _createElementVNode("td", _hoisted_81, _toDisplayString(response.code), 1),
                          _createElementVNode("td", _hoisted_82, [
                            _createElementVNode("div", _hoisted_83, [
                              _createElementVNode("div", _hoisted_84, [
                                (_ctx.editorMode)
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 0,
                                      class: _normalizeClass(["editable-field", { empty: !response.description }]),
                                      onClick: ($event: any) => (_ctx.editResponseDescr(response.code))
                                    }, _toDisplayString(response.description ||
															"Add response description..."), 11, _hoisted_85))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_86, _toDisplayString(response.description || ""), 1))
                              ])
                            ]),
                            _createElementVNode("section", _hoisted_87, [
                              _createElementVNode("div", _hoisted_88, [
                                _hoisted_89,
                                (response.code === '200')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createElementVNode("div", _hoisted_90, [
                                        _withDirectives(_createElementVNode("select", {
                                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.request.accept) = $event)),
                                          id: 'select-accept' + _ctx.operationSuffix,
                                          class: "content-type"
                                        }, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(
																		response.content
																	), (contentType) => {
                                            return (_openBlock(), _createElementBlock("option", { value: contentType }, _toDisplayString(contentType), 9, _hoisted_92))
                                          }), 256))
                                        ], 8, _hoisted_91), [
                                          [_vModelSelect, _ctx.request.accept]
                                        ])
                                      ]),
                                      _hoisted_93
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ]),
                          _hoisted_94
                        ], 8, _hoisted_80))
                      }), 256))
                    ])
                  ])
                ])
              ])
            ], 8, _hoisted_9))
          : _createCommentVNode("", true)
      ])
    ], 10, _hoisted_2)
  ], 512))
}